import React, { memo, useEffect, useState } from "react";
import stylesPc from "./VideoSuggestionsPanel.module.css";
import stylesSp from "./VideoSuggestionsPanel_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../root/RootReducer";
import VideoSuggestion from "./VideoSuggestion";
import { filterVideoList } from "../../../../common/video/VideoActions";
import PuiTypography from "../../../../components/elements/PuiTypography";

const MAX_SUGGESTION_COUNT = 3;
let otherVideoIds: number[];

interface VideoSuggestionsPanelProps {
    videoId?: number;
}

function VideoSuggestionsPanel({ videoId }: VideoSuggestionsPanelProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const { userInfo } = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo,
    }));

    const { list, videos } = useSelector(({ video }: AppState) => video);

    const dispatch = useDispatch();
    const [hasTriedLoadingMore, setHasTriedLoadingMore] = useState<boolean>(false);

    useEffect(() => {
        otherVideoIds = list;
        if (videoId) {
            otherVideoIds = list.filter((id) => id !== videoId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoId, videos]);

    useEffect(() => {
        let videoFilter = {
            id: [],
            professional: [],
            program: [],
            project: [],
            tag: [],
        };
        if (!hasTriedLoadingMore && list.length <= 1) {
            // 全Videoを取得
            if (userInfo) dispatch(filterVideoList(userInfo.id, videoFilter));
            setHasTriedLoadingMore(true);
        }
    }, [dispatch, hasTriedLoadingMore, list, userInfo]);

    return (
        <div className={styles.root}>
            <PuiTypography color={"white"} bold={true} size={20}>
                新着動画
            </PuiTypography>
            <div className={styles.list}>
                {otherVideoIds && otherVideoIds.length > 0 ? (
                    otherVideoIds
                        .slice(0, MAX_SUGGESTION_COUNT)
                        .map((id) => <VideoSuggestion key={id} video={videos[id]} />)
                ) : (
                    <div style={{ color: "var(--primary-font)" }}>新着動画がありません</div>
                )}
            </div>
        </div>
    );
}

export default memo(VideoSuggestionsPanel);
